export const OBFUSCATE_BEARER_TOKEN = 'Bearer *****';
